import type { CSSProperties } from 'react';

type ColumnShape = {
  fixed?: unknown;
  children?: object[];
  onCell?: (...args: never[]) => { style?: CSSProperties };
  onHeaderCell?: (...args: never[]) => { style?: CSSProperties };
};

// 保留列级回调，并为固定列补充不透明主题背景；行状态通过 CSS 变量同步。
export function themeTableColumns<T extends object>(columns: T[]): T[] {
  return columns.map((column) => {
    const item = column as ColumnShape;
    const result = { ...column } as T & ColumnShape;
    if (item.children) result.children = themeTableColumns(item.children);
    if (item.fixed) {
      result.onCell = (...args) => {
        const props = item.onCell?.(...args) || {};
        return {
          ...props,
          style: {
            ...props.style,
            background:
              'var(--platform-row-background, var(--ant-color-bg-container))',
            backgroundImage: 'none',
            opacity: 1,
            zIndex: 2,
          },
        };
      };
      result.onHeaderCell = (...args) => {
        const props = item.onHeaderCell?.(...args) || {};
        return {
          ...props,
          style: {
            ...props.style,
            background:
              'var(--ant-table-header-bg, var(--ant-color-bg-container))',
            backgroundImage: 'none',
            opacity: 1,
            zIndex: 3,
          },
        };
      };
    }
    return result;
  });
}
